export default __webpack_public_path__ + "static/media/publications_icon.bc2cf636.svg";